import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { Col } from 'react-bootstrap';
import HeaderEdit from './editing/HeaderEdit';
import ReceiveClientCardEdit from './editing/ReceiveClientCardEdit';
import InputValuesEdit from './editing/InputValuesEdit';
import NegotiatedValuesEdit from './editing/NegotiatedValuesEdit';
import ShipmentDiscountsEdit from './editing/ShipmentDiscountsEdit';
import ShipmentTransferEdit from './editing/ShipmentTransferEdit';
import Text from '../Text';
import Card from '../Card';
import FreightValuesContext, { useFreightValues } from './context';
import Button from '../Button';
import ReceiveClientCardShow from './show/ReceiveClientCardShow';
import InputValuesShow from './show/InputValuesShow';
import NegotiatedValuesShow from './show/NegotiatedValuesShow';
import ShipmentDiscountsShow from './show/ShipmentDiscountsShow';
import ShipmentTransferShow from './show/ShipmentTransferShow';
import SummaryPayingTransporterCardShow from './show/SummaryPayingTransporterCardShow';
import HeaderShow from './show/HeaderShow';

const FreightValuesRef = forwardRef(
  (
    { 
      cargoValue,
      handleSubmit,
      disableEditing,
      showHeaderButtons,
      loading,
      isNational,
      totalKm
    },
    ref
  ) => {
    const {
      init,
      getValues,
      setCargoValue,
      setTotalKm,
      isAttended,
      resetData,
      setInsuranceValueBenner,
      setCustomerFields,
      convertValueToCurrency,
      errors
    } = useFreightValues();
    const [editing, setEditing] = useState(false);

    useImperativeHandle(ref, () => ({
      getValues,
      init,
      setInsuranceValueBenner,
      setCustomerFields,
      convertValueToCurrency,
      errors,
    }));

    useEffect(() => {
      setCargoValue(cargoValue);
    }, [cargoValue]);

    useEffect(() => {
      setTotalKm(totalKm);
    }, [totalKm]);

    function onCancel() {
      resetData();
      setEditing(false);
    }

    async function onSubmit() {
      const submited = await handleSubmit();
      if (submited) {
        setEditing(false);
      }
    }

    return (
      <Col xs={12}>
        <Card
          header={<Text type="header">Composição de valores de frete</Text>}
          bodyCardPadding="2rem"
          HeaderRightComponent={
            showHeaderButtons && (
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                {editing ? (
                  <>
                    <Button
                      variant="secondary"
                      loading={loading}
                      onClick={onCancel}
                      id="button-cancelar-card-frete"
                    >
                      <Text color="dark" type="regular">
                        Cancelar
                      </Text>
                    </Button>
                    <Button
                      disabled={disableEditing}
                      loading={loading}
                      onClick={onSubmit}
                      variant="primary"
                      id="button-salvar"
                    >
                      <Text color="white" type="regular">
                        Salvar
                      </Text>
                    </Button>
                  </>
                ) : (
                  <Button
                    disabled={disableEditing}
                    onClick={() => setEditing(true)}
                    loading={loading}
                    variant="secondary"
                    id="button-editar"
                  >
                    <Text color="dark" type="regular">
                      Editar
                    </Text>
                  </Button>
                )}
              </div>
            )
          }
        >
          {editing ? (
            <>
              <HeaderEdit disableCurrency isNational={isNational} />
              <ReceiveClientCardEdit />
              <InputValuesEdit />
              <NegotiatedValuesEdit />
              <ShipmentDiscountsEdit />
              <ShipmentTransferEdit/>
            </>
          ) : (
            <>
              <HeaderShow isNational={isNational} />
              <ReceiveClientCardShow />
              <InputValuesShow />
              <NegotiatedValuesShow />
              <ShipmentDiscountsShow />
              <ShipmentTransferShow />
              {isAttended && <SummaryPayingTransporterCardShow />}
            </>
          )}
        </Card>
      </Col>
    );
  }
);

export default forwardRef(
  (
    { 
      cargoValue,
      totalKm,
      handleSubmit,
      disableEditing,
      showHeaderButtons,
      loading,
      isNational
    },
    ref
  ) => {
    return (
      <FreightValuesContext>
        <FreightValuesRef
          ref={ref}
          loading={loading}
          cargoValue={cargoValue}
          totalKm={totalKm}
          handleSubmit={handleSubmit}
          disableEditing={disableEditing}
          showHeaderButtons={showHeaderButtons}
          isNational={isNational}
          />
      </FreightValuesContext>
    );
  }
);
